// extracted by mini-css-extract-plugin
var _1 = "feedback-form__inline__NL64y";
export { _1 as "feedback-form__inline" }
